<template>
	<transition leave-active-class="animated fadeOut faster">
		<div v-if="!accepted">
			<span>We use cookies on this site to enhance your user experience. By clicking any link on this page you are giving your consent for us to use cookies.</span>
			<a @click="accept" style="font-size:1.5rem;margin-left: auto;">&#215;</a>
		</div>
	</transition>
</template>

<script>
export default {
	data: () => ({
		accepted: false
	}),
	created() {
		this.accepted = localStorage.getItem('cookiesAccepted') || false;
	},
	methods: {
		accept() {
			localStorage.setItem('cookiesAccepted', true);
			this.accepted = true;
		}
	}
};
</script>

<style scoped>
div {
	position: absolute;
    width: 100%;
    background: rgba(0, 0, 0, 0.7);
    color: white;
    padding: 0.5rem 1rem;
    display: flex;
    align-items: center;
    z-index: 2;
    font-size: 0.91rem;
}

span {
	text-transform: initial;
}
</style>

